import debug from 'debug';

const log = debug('ValidateForm:Static:Behaviour');

class Behaviour {
	static eventKeys = Object.freeze({
		// naming - [dispatcher class OR behavior] : [listener class : property]
		fieldIsValid: 'fieldIsValid'
	})

	static dispatchEvent(eventKey, options) {
		log('dispatchEvent() - eventKey, options', eventKey, options);
		const customEvent = new CustomEvent(eventKey, {
			detail: {
				options
			}
		});
		document.dispatchEvent(customEvent);
	}
}

export default Behaviour;
